import { useContext } from "react";
import PrimaryButton from "../common/PrimaryButton";
import { useNavigate } from "react-router-dom";
import linkdin from "../../assets/svgs/linkdinicon.svg";
import facebook from "../../assets/svgs/facebookicon1.svg";
import youtube from "../../assets/svgs/youtubeicon.svg";
import insta from "../../assets/svgs/instagramicon.svg";
import { AuthContext } from "../../context/AuthContext";
// import snowflake from "../../assets/images/snowFlake.png"
// import snowman from "../../assets/images/snowman.png"
// import santa from "../../assets/images/santa.png"
// import gifts from "../../assets/images/gifts.png"

const NewHomeHero = () => {
  const navigate = useNavigate();
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div className="relative overflow-hidden">
      <div
        className={`${theme === "dark" ? "bg-white" : "bg-black"
          } transition-all duration-500 overflow-hidden h-[500px] sm:h-[600px]`}
      >
        <div className="hidden lg:block max-w-screen-2xl mx-auto px-5 lg:px-20 py-8 lg:py-28 relative">
          <div className="absolute  left-80 top-[0%] sm:top-[300px] -translate-y-1/2 -translate-x-1/2">
            <svg
              width="150"
              height="150"
              viewBox="0 0 217 217"
              fill="none"
              className="w-[180px] sm:w-[200px] h-[180px] sm:h-[200px]   animate-spin-slow"
            >
              <g opacity="0.25">
                <circle
                  cx="108.5"
                  cy="108.5"
                  r="59"
                  stroke={theme === "dark" ? "black" : "white"}
                  strokeDasharray="11 11"
                />
                <circle
                  cx="108.5"
                  cy="108.5"
                  r="86"
                  stroke={theme === "dark" ? "black" : "white"}
                  strokeDasharray="11 11"
                />
                <circle
                  cx="108.5"
                  cy="108.5"
                  r="108"
                  stroke={theme === "dark" ? "black" : "white"}
                  strokeDasharray="11 11"
                />
              </g>
            </svg>
          </div>
          <div className="">
            <img
              src={facebook}
              alt="figma-logo"
              className="popup rounded-full z-40 icon-shadow  size-16 cursor-pointer absolute left-[292px] sm:left-[290px] top-[64%] sm:top-[52%] -translate-x-1/2 -translate-y-1/2"
              onClick={() =>
                window.open(
                  "https://www.facebook.com/hellotechqilla/",
                  "_blank"
                )
              }
            />
          </div>

          <div className="absolute right-80 top-[70%] sm:top-[300px] -translate-y-1/2 translate-x-1/2">
            <svg
              width="150"
              height="150"
              viewBox="0 0 217 217"
              fill="none"
              className="w-[180px] sm:w-[200px] h-[180px] sm:h-[200px] animate-spin-slow-reverse"
            >
              <g opacity="0.25">
                <circle
                  cx="108.5"
                  cy="108.5"
                  r="59"
                  stroke={theme === "dark" ? "black" : "white"}
                  strokeDasharray="11 11"
                />
                <circle
                  cx="108.5"
                  cy="108.5"
                  r="86"
                  stroke={theme === "dark" ? "black" : "white"}
                  strokeDasharray="11 11"
                />
                <circle
                  cx="108.5"
                  cy="108.5"
                  r="108"
                  stroke={theme === "dark" ? "black" : "white"}
                  strokeDasharray="11 11"
                />
              </g>
            </svg>
          </div>
          <img
            src={youtube}
            alt="react-logo"
            className="absolute popup z-10 rounded-full icon-shadow right-[292px] sm:right-[290px] top-[64%] sm:top-[52%] -translate-x-1/2 -translate-y-1/2 size-16"
            onClick={() =>
              window.open("https://www.youtube.com/@TechQilla", "_blank")
            }
          />
          <div
            className={`${theme === "dark" ? "" : "text-white"
              } transition-all duration-500 flex flex-col items-center`}
          >
            <div className="justify-items-center mb-5">
              <h2 className="bricolage-grotesque-bold font-bold text-3xl sm:text-4xl xl:text-6xl">
              Bold Brands Aren’t Born. 
              </h2>
              <h2 className="mt-2 bricolage-grotesque-bold font-bold text-3xl sm:text-4xl xl:text-6xl">
                They’re Built { " "}
                <span className="kaushan-script-regular text-gradient">
                with Us!
                </span>
              </h2>
            </div>
            <div className="mx-auto text-center max-w-xl z-10 text-[18px] opacity-50 mb-5 font-gtAmerica">
            We help people and businesses build brands they’re proud of through strategy, content, design and everything it takes to show up with confidence and clarity.
            </div>
            <div onClick={() => navigate("/contact")}>
              <PrimaryButton
                className={`${theme === "dark"
                    ? "hover:bg-secondary hover:border-secondary bg-black text-white hover:shadow-[0_0_10px_2px] hover:shadow-secondary"
                    : "border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary montserrat-medium"
                  } relative z-20 border`}
              >
                Let's Talk
              </PrimaryButton>
            </div>
          </div>
          <a
            className="absolute bottom-10 sm:bottom-0 left-28 sm:left-20 z-40 blur-[3px] lnr"
            href="https://in.linkedin.com/company/techqilla"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={linkdin}
              className="size-16 sm:size-auto opacity-50 sm:opacity-100"
              alt="linkdin"
            />
          </a>
          <a
            className="absolute bottom-10 sm:bottom-0 right-28 sm:right-20 z-40 blur-[3px] lnr-2"
            href="https://www.instagram.com/techqilla_/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={insta}
              className="size-16 sm:size-auto opacity-50 sm:opacity-100"
              alt="insta"
            />
          </a>
        </div>
        <div className={`${theme === "dark" ? "text-black" : "text-white"} px-5 py-10 sm:hidden`}>
          <div className={` justify-items-center mb-5 mt-10`}>
            <h2 className="bricolage-grotesque-bold font-bold text-3xl text-center">
            Bold Brands Aren’t Born. 
            They’re Built {" "}
              <span className="kaushan-script-regular text-gradient">
                with Us
              </span>
            </h2>
          </div>
          <div className="mx-auto text-center max-w-xl z-10 text-[18px] opacity-50 mb-5 font-gtAmerica">
          We help people and businesses build brands they’re proud of through strategy, content, design and everything it takes to show up with confidence and clarity.
          </div>
          <div className="flex justify-center" onClick={() => navigate("/contact")}>
            <PrimaryButton
              className={`${theme === "dark"
                  ? "hover:bg-secondary hover:!border-secondary bg-black text-white hover:shadow-[0_0_10px_2px] hover:shadow-secondary"
                  : "border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                } relative z-20 border`}
            >
              Let's Talk
            </PrimaryButton>
          </div>
        </div>
      </div>
      <svg
        width="1444"
        height="1292"
        viewBox="0 0 1444 1292"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-[300px] sm:top-[150px] -left-[25%] sm:left-0 sm:right-0 sm:mx-auto h-full sm:h-auto w-[600px] sm:w-full"
      >
        <g filter="url(#filter0_f_3562_1617)">
          <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
        </g>
        <defs>
          <filter
            id="filter0_f_3562_1617"
            x="-173.6"
            y="0.399994"
            width="1791.2"
            height="1291.2"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="126.3"
              result="effect1_foregroundBlur_3562_1617"
            />
          </filter>
        </defs>
      </svg>
      <svg
        width="790"
        height="786"
        viewBox="0 0 790 786"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute mx-auto -left-[15%] sm:left-0 right-0 top-[400px] sm:top-[450px] h-full sm:h-auto w-[500px] sm:w-auto positive-animate-spin1"
      >
        <path
          d="M789.5 393C789.5 609.769 612.879 785.5 395 785.5C177.121 785.5 0.5 609.769 0.5 393C0.5 176.231 177.121 0.5 395 0.5C612.879 0.5 789.5 176.231 789.5 393Z"
          stroke="white"
        />
        <g filter="url(#filter0_f_3804_1744)">
          <circle cx="136" cy="95" r="9" fill="#F20B97" />
        </g>
        <defs>
          <filter
            id="filter0_f_3804_1744"
            x="113"
            y="72"
            width="46"
            height="46"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7"
              result="effect1_foregroundBlur_3804_1744"
            />
          </filter>
        </defs>
      </svg>
      {/* <img src={snowman} alt="" className="absolute bottom-0 md:-bottom-14 left-0 md:left-64 z-40 animate-bounce size-24 md:size-auto" />
      <img src={santa} alt="" className="absolute bottom-0 md:-bottom-14 right-0 md:right-64 z-40 animate-bounce delay-500 size-24 md:size-auto" /> */}
    </div>
  );
};

export default NewHomeHero;
